'use client';

import { Book } from 'types';
import useRecentViews from '@/lib/hooks/use-recent-views';

interface RecentViewsClientProps {
  book: Book;
}

export default function RecentViewsClient({ book }: RecentViewsClientProps) {
  useRecentViews({ book });
  // Return null since this component doesn't render anything
  return null;
}
